import src from "IMAGE";
export default { src, width: 1993, height: 1947, blurWidth: 0, blurHeight: 0};
